// eslint-disable-next-line import/prefer-default-export
export const Failures = {
  BILLING: 'billing',
  PAYMENT: 'payment'
};
